// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-text-button-81134393"};